import { normalizeUser } from "./user";
import { createContext } from "react";
import { normalizeOrg } from "./organization";

export function unwrapUserContextData(
  data: IUserContextData
): IUserContextLegacy {
  return {
    user: data.user.data,
    org: data.organization.data,
  };
}

export function normalizeUserContextData(
  data: IUserContextData
): IUserContextNormalized {
  const userData = data.user.data;
  const orgData = data.organization.data;

  const user = normalizeUser(userData);
  const org = normalizeOrg(orgData);

  return { user, org };
}

export const RailsUserContext = createContext<
  IUserContextNormalized | undefined
>(undefined);



// WEBPACK FOOTER //
// ./app/javascript/libs/user_context.ts